module.exports = __webpack_public_path__ + "static/media/cures.3283670d.mp3";